export enum ArticleSortOrder {
  Default = "default",
  PriceAsc = "price_asc",
  PriceDesc = "price_desc",
  NameAsc = "name_asc",
  NameDesc = "name_desc",
  RateAsc = "rate_asc",
  PopularAsc = "popular_asc",
}

const sortOrderLabels: Record<ArticleSortOrder, string> = {
  [ArticleSortOrder.Default]: "Sortiranje",
  [ArticleSortOrder.PriceAsc]: "Cijena rastuće",
  [ArticleSortOrder.PriceDesc]: "Cijena opadajuće",
  [ArticleSortOrder.NameAsc]: "Naziv rastuće",
  [ArticleSortOrder.NameDesc]: "Naziv opadajuće",
  [ArticleSortOrder.RateAsc]: "Ocjena rastuće",
  [ArticleSortOrder.PopularAsc]: "Popularnost",
};

interface SortMenuItem {
  key: ArticleSortOrder;
  label: string;
}
// todo
export const sortOrderItems: SortMenuItem[] = [
  ArticleSortOrder.Default,
  ArticleSortOrder.PriceAsc,
  ArticleSortOrder.PriceDesc,
  ArticleSortOrder.NameAsc,
  ArticleSortOrder.NameDesc,
  ArticleSortOrder.RateAsc,
  ArticleSortOrder.PopularAsc,
].map((key) => ({ key, label: sortOrderLabels[key] }));
